// This is the webpack entry point
// Refrain from putting actual code in here and just import the modules you need; 
// import './map'

import './global/nav';

import './carousel/image-carousel';
import './carousel/testimonial-carousel';

import './lightbox/lightbox.js';

import './posts/post_feed';

import './hero/hero';

/* eslint-disable */
window.initMap = () => {
}